module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/136-iran-dac1cef3e6d311414914348e80d346be.svg";